import { useStyle } from '@/classify';
import Icon from '@/components/Icon';
import { useCallback } from 'react';
import { ChevronDown as ArrowDown, ChevronRight as ArrowRight } from 'react-feather';
import { useAccordionContext } from './accordion';
import defaultClasses from './section.module.css';

const Section = props => {
  const {
    children,
    id,
    title,
    isShowIcon = true,
    customOpenIcon, // 新增prop：自定义展开图标
    customCloseIcon, // 新增prop：自定义收起图标
    ...restProps
  } = props;

  // Remove isOpen from restProps to avoid having it in the root container
  delete restProps.isOpen;

  const { handleSectionToggle, openSectionIds } = useAccordionContext();

  const handleSectionToggleWithId = useCallback(() => handleSectionToggle(id), [handleSectionToggle, id]);

  const isOpen = openSectionIds.has(id);
  const titleIconSrc = isOpen
    ? customOpenIcon || ArrowDown // 优先使用自定义展开图标
    : customCloseIcon || ArrowRight; // 优先使用自定义收起图标
  const titleIcon = isShowIcon ? (
    <Icon
      src={titleIconSrc}
      size={24}
    />
  ) : null;

  const classes = useStyle(defaultClasses, props.classes);
  const contentsContainerClass = isOpen ? classes.contents_container : classes.contents_container_closed;

  return (
    <div
      className={classes.root}
      {...restProps}
    >
      <button
        className={classes.title_container}
        onClick={handleSectionToggleWithId}
        type='button'
      >
        <span className={classes.title_wrapper}>
          <h2 className={classes.title}>{title}</h2>
          {titleIcon}
        </span>
      </button>
      <div className={contentsContainerClass}>{children}</div>
    </div>
  );
};

export default Section;
